import React, { useState } from 'react';
import cn from "classnames";
import style from "./common.module.scss";
import CustomDatePicker from '../shared/date-picker/Date';
import CustomButton from '../custom/custom-button/CustomButton';
import CalendarIcon from '../shared/icons/CalendarIcon';
import { numberToFinanceFormat } from '../../utils';
import {t} from "i18next";

const BasicAnalytics = ({ startDate, setStartDate, item, endtDate, setEndtDate }) => {

    return (
        <>
            <div className={style.filter}>
                <div className={style.filter_date}>
                    <CustomDatePicker
                        dateFormat="dd.MM.yyyy"
                        placeholderText={t('analytics.pickDate')}
                        withBorder
                        IconStart={<CalendarIcon />}
                        selected={startDate}
                        onChange={(date) => {
                            setStartDate(date);
                            console.log(date);
                        }}
                    />
                    <CustomDatePicker
                        dateFormat="dd.MM.yyyy"
                        placeholderText={t('analytics.pickDate')}
                        withBorder
                        IconStart={<CalendarIcon />}
                        selected={endtDate}
                        onChange={(date) => {
                            setEndtDate(date);
                            console.log(date);
                        }}
                    />
                </div>
                {/* <CustomButton text="Экспорт" isMain /> */}
            </div>

            <div className={style.metric}>
                <div className={style.metric_item}>
                    <div className={style.metric_title}>{t('analytics.orders')}</div>
                    <div className={style.metric_number}>{numberToFinanceFormat(item?.totalOrders)}</div>
                </div>
                <div className={style.metric_item}>
                    <div className={style.metric_title}>{t('analytics.completed')}</div>
                    <div className={style.metric_number}>{numberToFinanceFormat(item?.completedOrders)}</div>
                </div>
                <div className={style.metric_item}>
                    <div className={style.metric_title}>{t('analytics.canceled')}</div>
                    <div className={style.metric_number}>{numberToFinanceFormat(item?.canceledOrders)}</div>
                </div>
                <div className={style.metric_item}>
                    <div className={style.metric_title}>{t('analytics.onTrip')}</div>
                    <div className={style.metric_number}>{numberToFinanceFormat(item?.onTheWayOrders)}</div>
                </div>
            </div>

            <div className={style.metric}>
                <div className={style.metric_item}>
                    <div className={style.metric_title}>{t('analytics.avgOrderPrice')}</div>
                    <div className={style.metric_number}>{numberToFinanceFormat(item?.averageSum, true)}〒</div>
                </div>
                <div className={style.metric_item}>
                    <div className={style.metric_title}>{t('analytics.distance')}</div>
                    <div className={style.metric_number}>{numberToFinanceFormat(item?.totalDistance, true)} {t('analytics.distance_metric')}</div>
                </div>
            </div>
        </>
    );
}

export default BasicAnalytics;
